// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import toast, { Toaster } from "react-hot-toast";
// import "../assets/css/nominee.css";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// const NomineeManagement = () => {
//   const dispatch = useDispatch();

//   const [formData, setFormData] = useState({
//     nomineeName: "",
//     nomineeRelation: "",
//     nomineeDob: "",
//     nomineeMobile: "",
//     nomineeAadhar: "",
//     nomineePan: "",
//     customerId: "",
//     accountId: "",
//     nomineePhoto: null,
//   });

//   const [nominees, setNominees] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [search, setSearch] = useState("");
//   const [deleteModal, setDeleteModal] = useState(false);
//   const [selectedNominee, setSelectedNominee] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);

//   const { profile } = useSelector((state) => state.userProfile);

//   // Fetch profile on mount
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   useEffect(() => {
//     fetchNominees();
//   }, []);

//   // ✅ Fetch all nominees
//   const fetchNominees = async () => {
//       const branchId = Number(localStorage.getItem("userId")) || 0;

//     try {
//       const res = await axios.get(`https://narrowitsolution.in/api/customer-nominee-all?branchId=${branchId}`);
//       const data =
//         res.data.nominees ||
//         res.data.data ||
//         res.data.allNominees ||
//         (Array.isArray(res.data) ? res.data : []);
//       setNominees(Array.isArray(data) ? data : []);
//     } catch {
//       toast.error("Failed to load nominees.");
//       setNominees([]);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files && files[0]) {
//       setFormData({ ...formData, [name]: files[0] });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };

//   // ✅ CREATE NOMINEE (with profile IDs)
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const { nomineeName, nomineeRelation, nomineeDob, nomineeMobile } = formData;
//     if (!nomineeName || !nomineeRelation || !nomineeDob || !nomineeMobile) {
//       toast.error("All required fields must be filled.");
//       return;
//     }

//     // ✅ Ensure profile is loaded
//     if (!profile || !profile.superAdminId || !profile.branchId) {
//       toast.error("Profile data missing. Please reload page.");
//       return;
//     }

//     try {
//       setLoading(true);
//       const formDataObj = new FormData();

//       // ✅ Append profile IDs
//       formDataObj.append("superAdminId", profile.superAdminId);
//       formDataObj.append("branchId", profile.id);

//       // ✅ Append all form fields
//       for (const key in formData) {
//         formDataObj.append(key, formData[key]);
//       }

//       await axios.post("https://narrowitsolution.in/api/customer-create-nominee", formDataObj, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       toast.success("Nominee created successfully!");
//       resetForm();
//       fetchNominees();
//     } catch (err) {
//       toast.error("Failed to create nominee.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ UPDATE NOMINEE (with profile IDs)
//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     if (!profile || !profile.superAdminId || !profile.id) {
//       toast.error("Profile data missing. Please reload page.");
//       return;
//     }

//     try {
//       setLoading(true);
//       const formDataObj = new FormData();

//       formDataObj.append("superAdminId", profile.superAdminId);
//       formDataObj.append("branchId", profile.id);

//       for (const key in formData) {
//         formDataObj.append(key, formData[key]);
//       }

//       await axios.put(
//         `https://narrowitsolution.in/api/customer-nominee-update/${selectedNominee.id}`,
//         formDataObj,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       toast.success("Nominee updated successfully!");
//       resetForm();
//       fetchNominees();
//     } catch {
//       toast.error("Failed to update nominee.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       nomineeName: "",
//       nomineeRelation: "",
//       nomineeDob: "",
//       nomineeMobile: "",
//       nomineeAadhar: "",
//       nomineePan: "",
//       customerId: "",
//       accountId: "",
//       nomineePhoto: null,
//     });
//     setIsEditMode(false);
//     setSelectedNominee(null);
//   };

//   const handleEdit = (nominee) => {
//     setSelectedNominee(nominee);
//     setIsEditMode(true);
//     setFormData({
//       nomineeName: nominee.nomineeName || "",
//       nomineeRelation: nominee.nomineeRelation || "",
//       nomineeDob: nominee.nomineeDob || "",
//       nomineeMobile: nominee.nomineeMobile || "",
//       nomineeAadhar: nominee.nomineeAadhar || "",
//       nomineePan: nominee.nomineePan || "",
//       customerId: nominee.customerId || "",
//       accountId: nominee.accountId || "",
//       nomineePhoto: null,
//     });
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const openDeleteModal = (nominee) => {
//     setSelectedNominee(nominee);
//     setDeleteModal(true);
//   };

//   const handleDelete = async () => {
//     try {
//       await axios.delete(`https://narrowitsolution.in/api/customer-nominee-delete/${selectedNominee.id}`);
//       toast.success("Nominee deleted successfully!");
//       setDeleteModal(false);
//       fetchNominees();
//     } catch {
//       toast.error("Failed to delete nominee.");
//     }
//   };

//   const filteredNominees = (nominees || []).filter(
//     (n) =>
//       n.nomineeName?.toLowerCase().includes(search.toLowerCase()) ||
//       n.nomineeMobile?.toLowerCase().includes(search.toLowerCase()) ||
//       n.nomineeRelation?.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div className="nominee-wrapper">
//       <div className="nominee-container">
//         <Toaster position="top-right" />
//         <h2 className="nominee-form-title">
//           {isEditMode ? "Edit Nominee" : "Add Nominee"}
//         </h2>

//         {/* ✅ Add/Edit Nominee Form */}
//         <form
//           onSubmit={isEditMode ? handleUpdate : handleSubmit}
//           encType="multipart/form-data"
//         >
//           <div className="nominee-grid">
//             {[
//               { name: "nomineeName", label: "Nominee Name" },
//               { name: "nomineeRelation", label: "Relation" },
//               { name: "nomineeDob", label: "Date of Birth", type: "date" },
//               { name: "nomineeMobile", label: "Mobile" },
//               { name: "nomineeAadhar", label: "Aadhar No" },
//               { name: "nomineePan", label: "PAN No" },
//               { name: "customerId", label: "Customer ID" },
//             ].map((field) => (
//               <div className="nominee-form-group" key={field.name}>
//                 <label>{field.label}</label>
//                 <input
//                   type={field.type || "text"}
//                   name={field.name}
//                   value={formData[field.name]}
//                   onChange={handleChange}
//                   placeholder={field.label}
//                 />
//               </div>
//             ))}

//             <div className="nominee-form-group">
//               <label>{isEditMode ? "Update Photo (Optional)" : "Nominee Photo"}</label>
//               <input
//                 type="file"
//                 name="nomineePhoto"
//                 accept="image/*"
//                 onChange={handleChange}
//               />
//             </div>
//           </div>

//           <div className="form-buttons">
//             <button type="submit" className="nominee-submit-button" disabled={loading}>
//               {loading
//                 ? "Processing..."
//                 : isEditMode
//                 ? "Update Nominee"
//                 : "Save Nominee"}
//             </button>
//             {isEditMode && (
//               <button type="button" onClick={resetForm} className="cancel-btn">
//                 Cancel Edit
//               </button>
//             )}
//           </div>
//         </form>

//         {/* ✅ Nominee Table */}
//         <section className="nominee-table-section">
//           <h2>Nominee List</h2>
//           <input
//             type="text"
//             placeholder="Search by name, relation or mobile..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             className="nominee-search"
//           />

//           <div className="table-responsive">
//             <table className="nominee-table">
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Photo</th>
//                   <th>Customer ID</th>
//                   <th>Name</th>
//                   <th>Relation</th>
//                   <th>DOB</th>
//                   <th>Mobile</th>
//                   <th>Aadhar</th>
//                   <th>PAN</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredNominees.length > 0 ? (
//                   filteredNominees.map((n, i) => (
//                     <tr key={n.id || i}>
//                       <td>{i + 1}</td>
//                       <td>
//                         {n.nomineePhoto ? (
//                           <img
//                             src={`https://narrowitsolution.in/uploads/${n.nomineePhoto}`}
//                             alt="Nominee"
//                             className="nominee-photo-thumb"
//                           />
//                         ) : (
//                           <span>No Photo</span>
//                         )}
//                       </td>
//                       <td>{n.customerId}</td>
//                       <td>{n.nomineeName}</td>
//                       <td>{n.nomineeRelation}</td>
//                       <td>{n.nomineeDob}</td>
//                       <td>{n.nomineeMobile}</td>
//                       <td>{n.nomineeAadhar}</td>
//                       <td>{n.nomineePan}</td>
//                       <td>
//                         <button className="action-btn edit-btn" onClick={() => handleEdit(n)}>
//                           ✏️
//                         </button>
//                         <button className="action-btn delete-btn" onClick={() => openDeleteModal(n)}>
//                           🗑️
//                         </button>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="10">No nominees found.</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </section>

//         {/* Delete Modal */}
//         {deleteModal && (
//           <div className="modal-overlay">
//             <div className="modal-box delete-box">
//               <h3>Confirm Delete</h3>
//               <p>Are you sure you want to delete this nominee?</p>
//               <div className="modal-actions">
//                 <button onClick={handleDelete} className="delete-btn">
//                   Yes, Delete
//                 </button>
//                 <button onClick={() => setDeleteModal(false)} className="cancel-btn">
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default NomineeManagement;

import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import {toast} from "react-toastify";
import "../assets/css/nominee.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { Edit, Trash } from "lucide-react";

const NomineeManagement = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    nomineeName: "",
    nomineeRelation: "",
    nomineeDob: "",
    nomineeMobile: "",
    nomineeAadhar: "",
    nomineePan: "",
    customerId: "",
    accountId: "",
    nomineePhoto: null,
  });
  const ITEMS_PER_PAGE_OPTIONS = [5, 10, 25,50];
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const [nominees, setNominees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedNominee, setSelectedNominee] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const { profile } = useSelector((state) => state.userProfile);

  // Fetch profile on mount
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    fetchNominees();
  }, []);

  // ✅ Fetch all nominees
  const fetchNominees = async () => {
    const branchId = Number(localStorage.getItem("userId")) || 0;

    try {
      const res = await axios.get(
        `https://narrowitsolution.in/api/customer-nominee-all?branchId=${branchId}`
      );
      const data =
        res.data.nominees ||
        res.data.data ||
        res.data.allNominees ||
        (Array.isArray(res.data) ? res.data : []);
      setNominees(Array.isArray(data) ? data : []);
      console.log("nominee photo",data)
    } catch {
      toast.error("Failed to load nominees.");
      setNominees([]);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files && files[0]) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // ✅ CREATE NOMINEE (with profile IDs)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const { nomineeName, nomineeRelation, nomineeDob, nomineeMobile } =
      formData;
    if (!nomineeName || !nomineeRelation || !nomineeDob || !nomineeMobile) {
      toast.error("All required fields must be filled.");
      return;
    }

    // ✅ Ensure profile is loaded
    if (!profile || !profile.superAdminId || !profile.branchId) {
      toast.error("Profile data missing. Please reload page.");
      return;
    }

    try {
      setLoading(true);
      const formDataObj = new FormData();

      // ✅ Append profile IDs
      formDataObj.append("superAdminId", profile.superAdminId);
      formDataObj.append("branchId", profile.id);

      // ✅ Append all form fields
      for (const key in formData) {
        formDataObj.append(key, formData[key]);
      }

      await axios.post(
        "https://narrowitsolution.in/api/customer-create-nominee",
        formDataObj,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast.success("Nominee created successfully!");
      resetForm();
      fetchNominees();
    } catch (err) {
      toast.error("Failed to create nominee.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ UPDATE NOMINEE (with profile IDs)
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!profile || !profile.superAdminId || !profile.id) {
      toast.error("Profile data missing. Please reload page.");
      return;
    }

    try {
      setLoading(true);
      const formDataObj = new FormData();

      formDataObj.append("superAdminId", profile.superAdminId);
      formDataObj.append("branchId", profile.id);

      for (const key in formData) {
        formDataObj.append(key, formData[key]);
      }

      await axios.put(
        `https://narrowitsolution.in/api/customer-nominee-update/${selectedNominee.id}`,
        formDataObj,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      toast.success("Nominee updated successfully!");
      resetForm();
      fetchNominees();
    } catch {
      toast.error("Failed to update nominee.");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      nomineeName: "",
      nomineeRelation: "",
      nomineeDob: "",
      nomineeMobile: "",
      nomineeAadhar: "",
      nomineePan: "",
      customerId: "",
      accountId: "",
      nomineePhoto: null,
    });
    setIsEditMode(false);
    setSelectedNominee(null);
  };

  const handleEdit = (nominee) => {
    setSelectedNominee(nominee);
    setIsEditMode(true);
    setFormData({
      nomineeName: nominee.nomineeName || "",
      nomineeRelation: nominee.nomineeRelation || "",
      nomineeDob: nominee.nomineeDob || "",
      nomineeMobile: nominee.nomineeMobile || "",
      nomineeAadhar: nominee.nomineeAadhar || "",
      nomineePan: nominee.nomineePan || "",
      customerId: nominee.customerId || "",
      accountId: nominee.accountId || "",
      nomineePhoto: null,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const openDeleteModal = (nominee) => {
    setSelectedNominee(nominee);
    setDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      await axios.delete(
        `https://narrowitsolution.in/api/customer-nominee-delete/${selectedNominee.id}`
      );
      toast.success("Nominee deleted successfully!");
      setDeleteModal(false);
      fetchNominees();
    } catch {
      toast.error("Failed to delete nominee.");
    }
  };

// const filteredData = useMemo(() => {
//   const searchText = searchQuery?.toLowerCase() || "";

//   return (nominees || []).filter((item) =>
//     item.nomineeName?.toLowerCase().includes(searchText) ||
//     item.nomineeRelation?.toLowerCase().includes(searchText) ||
//     String(item.nomineeMobile || "").includes(searchText)
//   );
// }, [nominees, searchQuery]);

  // Search + Pagination
  const filteredData = useMemo(() => {
    return nominees.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }, [nominees, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="nominee-container">
        <h1 className="nominee-heading">
          {" "}
          {isEditMode ? "Edit Nominee" : "Add Nominee"}
        </h1>

        {/* ✅ Add/Edit Nominee Form */}
        <section className="nominee-top">
          <form
            className="nominee-form"
            onSubmit={isEditMode ? handleUpdate : handleSubmit}
            encType="multipart/form-data"
          >
            <div className="nominee-form-section">
              <div className="nominee-form-input-fields">
                <label>Nominee Name</label>
                <input
                  type="text"
                  name="nomineeName"
                  value={formData.nomineeName}
                  onChange={handleChange}
                  placeholder="Nominee Name"
                />
              </div>

              <div className="nominee-form-input-fields">
                <label>Relation</label>
                <input
                  type="text"
                  name="nomineeRelation"
                  value={formData.nomineeRelation}
                  onChange={handleChange}
                  placeholder="Nominee Relation"
                />
              </div>

              <div className="nominee-form-input-fields">
                <label>Date of Birth</label>
                <input
                  type="date"
                  name="nomineeDob"
                  value={formData.nomineeDob}
                  onChange={handleChange}
                />
              </div>

              <div className="nominee-form-input-fields">
                <label>Mobile</label>
                <input
                  type="text"
                  name="nomineeMobile"
                  value={formData.nomineeMobile}
                  onChange={handleChange}
                  placeholder="Mobile"
                />
              </div>
              <div className="nominee-form-input-fields">
                <label>Aadhar No</label>
                <input
                  type="text"
                  name="nomineeAadhar"
                  value={formData.nomineeAadhar}
                  onChange={handleChange}
                  placeholder="Aadhaar No"
                />
              </div>
              <div className="nominee-form-input-fields">
                <label>PAN No</label>
                <input
                  type="text"
                  name="nomineePan"
                  value={formData.nomineePan}
                  onChange={handleChange}
                  placeholder="Pan No"
                />
              </div>
              <div className="nominee-form-input-fields">
                <label>Customer ID</label>
                <input
                  type="text"
                  name="customerId"
                  value={formData.customerId}
                  onChange={handleChange}
                  placeholder="Customer Id"
                />
              </div>
              <div className="nominee-form-input-fields">
                <label>{isEditMode ? "Update Photo (Optional)" : "Nominee Photo"}</label>
                <input
                  type="file"
                  name="nomineePhoto"
                  accept="image/*"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="nominee-form-submit-btn">
              <button type="submit" className="submit-btn">
                {loading
                ? "Processing..."
                : isEditMode
                ? "Update Nominee"
                : "Save Nominee"}
              </button>
              {isEditMode && (
              <button type="button" onClick={resetForm} className="cancel-btn">
                Cancel Edit
              </button>)}
            </div>
          </form>
        </section>

        {/* ================= REPORT SECTION ================= */}
        <div className="nominee-report-container">
          <h1>Nominee List</h1>
          <div className="nominee-report-filter-div">
            <input
              type="text"
              placeholder="Search by id..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            <div className="nominee-filter">
              <label>Show </label>
              <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
                {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
                <option value="100000">ALL</option>
              </select>
              <span> entries</span>
            </div>
          </div>

          <div className="nominee-report-table-container">
            <table className="nominee-report-table">
              <thead>
                <tr>
                  <th>#</th>
                   <th>Photo</th>
                   <th>Customer ID</th>
                   <th>Name</th>
                   <th>Relation</th>
                   <th>DOB</th>
                   <th>Mobile</th>
                   <th>Aadhar</th>
                   <th>PAN</th>
                   <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>
                        {item.nomineePhoto ? (
                          <img
                            src={`https://narrowitsolution.in/uploads/${item.nomineePhoto}`}
                            alt="Nominee"
                            className="nominee-photo-thumb"
                          />
                        ) : (
                          <span>No Photo</span>
                        )}
                      </td>
                      <td>{item.customerId||"N/A"}</td>
                      <td>{item.nomineeName||"N/A"}</td>
                      <td>{item.nomineeRelation||"N/A"}</td>
                      <td>{new Date(item.nomineeDob).toLocaleDateString("en-GB").replaceAll("/","-")||"N/A"}</td>
                      <td>{item.nomineeMobile||"N/A"}</td>
                      <td>{item.nomineeAadhar||"N/A"}</td>
                      <td>{item.nomineePan||"N/A"}</td>
                      <td>
                        <button className="action-btn edit-btn" onClick={() => handleEdit(item)}>
                           <Edit/>
                         </button>
                         <button className="action-btn delete-btn" onClick={() => openDeleteModal(item)}>
                           <Trash/>
                         </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" style={{ textAlign: "center" }}>
                     No nominees found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {filteredData.length > itemsPerPage && (
            <div className="nominee-pagination-div">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                ⬅ Prev
              </button>

              <span>
                {" "}
                Page {currentPage} of {totalPages}{" "}
              </span>

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next ➡
              </button>
            </div>
          )}


                  {/* Delete Modal */}
         {deleteModal && (
          <div className="nominee-modal-overlay">
            <div className="nominee-modal-box delete-box">
              <h3>Confirm Delete</h3>
              <p>Are you sure you want to delete this nominee?</p>
              <div className="nominee-modal-actions">
                <button onClick={handleDelete} className="delete-btn">
                  Yes, Delete
                </button>
                <button onClick={() => setDeleteModal(false)} className="cancel-btn">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        </div>
      </div>
    </>
  );
};

export default NomineeManagement;
